module.exports = __webpack_public_path__ + "static/media/s3-bottom-left-2.a38277a9.png";